// extracted by mini-css-extract-plugin
export default {"buttonContainer":"RenameModal__buttonContainer___xvuJa"};